import { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { firestore } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "./Reservations.css";
import concepts from "../data/conceptList";
import { useAlert } from "../context/AlertContext";
import ConfirmModal from "../components/ConfirmModal";

function formatDate(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function Reservations() {
  const [reservations, setReservations] = useState([]);
  const [filter, setFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();

  const conceptImages = concepts.reduce((acc, curr) => {
    acc[curr.name.toLowerCase()] = curr.image;
    return acc;
  }, {});

  useEffect(() => {
    const fetchReservations = async () => {
      const querySnapshot = await getDocs(collection(firestore, "reservations"));
      const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setReservations(data);
    };
    fetchReservations();
  }, []);

  const askDelete = (id) => setDeleteId(id);

  const confirmDelete = async () => {
    try {
      await deleteDoc(doc(firestore, "reservations", deleteId));
      setReservations(reservations.filter((res) => res.id !== deleteId));
      showSuccess("Silme işlemi başarılı", "Organizasyon silindi ✅", {
        emoji: "🗑️",
      });
    } catch (error) {
      console.error("Silme hatası:", error);
      showError("Silme başarısız", error.message, { emoji: "❌" });
    } finally {
      setDeleteId(null);
    }
  };

  const filteredReservations = reservations.filter((res) => {
    if (!res.eventDate) return false;
    const eventDate = new Date(res.eventDate);
    const today = new Date();

    let dateMatch = true;
    let statusMatch = true;

    if (filter === "week") {
      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + 7);
      dateMatch = eventDate >= today && eventDate <= endOfWeek;
    } else if (filter === "month") {
      dateMatch =
        eventDate.getMonth() === today.getMonth() &&
        eventDate.getFullYear() === today.getFullYear();
    }

    if (statusFilter !== "all") {
      statusMatch = res.status === statusFilter;
    }

    return dateMatch && statusMatch;
  });

  const searchedAndSorted = filteredReservations
    .filter((res) =>
      res.customerName?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      const dateA = new Date(a.eventDate);
      const dateB = new Date(b.eventDate);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

  return (
    <>
      <button
        onClick={() => navigate(-1)}
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          marginLeft: "1rem",
          backgroundColor: "#6c757d",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "8px 14px",
          fontSize: "15px",
          fontWeight: "500",
          cursor: "pointer",
        }}
      >
        ◀ Geri Dön
      </button>

      <div style={{ display: "flex", gap: "1rem", padding: "1rem 0" }}>
        <input
          type="text"
          placeholder="İsimle ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "0.5rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
            flex: 1,
          }}
        />
        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
          style={{
            padding: "0.5rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="asc">Tarihe göre (yakın → uzak)</option>
          <option value="desc">Tarihe göre (uzak → yakın)</option>
        </select>
      </div>

      <div className="filter-buttons">
        <button onClick={() => setFilter("all")} className={filter === "all" ? "active" : ""}>Tümü</button>
        <button onClick={() => setFilter("week")} className={filter === "week" ? "active" : ""}>Bu Hafta</button>
        <button onClick={() => setFilter("month")} className={filter === "month" ? "active" : ""}>Bu Ay</button>
      </div>

      <div className="filter-buttons">
        <button onClick={() => setStatusFilter("all")} className={statusFilter === "all" ? "active" : ""}>Tümü</button>
        <button onClick={() => setStatusFilter("hazirlanacak")} className={statusFilter === "hazirlanacak" ? "active" : ""}>Hazırlanacak</button>
        <button onClick={() => setStatusFilter("kuruldu")} className={statusFilter === "kuruldu" ? "active" : ""}>Kuruldu</button>
        <button onClick={() => setStatusFilter("toplandi")} className={statusFilter === "toplandi" ? "active" : ""}>Toplandı</button>
        <button onClick={() => setStatusFilter("tamamlandi")} className={statusFilter === "tamamlandi" ? "active" : ""}>Tamamlandı</button>
      </div>

      <div className="reservations-container">
        {searchedAndSorted.map((res) => {
          const conceptKey = (res.selectedConcept || res.concept || "").toLowerCase();
          const conceptImage = conceptImages[conceptKey] || "/placeholder.png";

          return (
            <div key={res.id} className="reservation-card">
              <img
                src={conceptImage}
                alt={res.selectedConcept || res.concept || "Konsept"}
                className="concept-thumb"
              />
              <h3>{res.customerName}</h3>
              <p>{formatDate(res.eventDate)}</p>
              <p>{res.location || "-"}</p>
              <p className={`status ${res.status}`}>{res.status}</p>

              <button onClick={() => navigate(`/event/${res.id}`)}>
                Detaya Git
              </button>

              <button
                onClick={() => askDelete(res.id)}
                style={{
                  marginTop: "0.5rem",
                  padding: "0.4rem 0.8rem",
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                🗑 Sil
              </button>
            </div>
          );
        })}
      </div>

      {deleteId && (
        <ConfirmModal
          message="Bu organizasyonu silmek istediğine emin misin?"
          onConfirm={confirmDelete}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </>
  );
}

export default Reservations;
